import { useState } from "react";
import Button from "./Button";
import TextInput from "./TextInput";

export const SubmissionMenu = (props) => {
    const [name, setName] = useState("");
    const [identification, setIdentification] = useState("");
    const [value, setValue] = useState(0);

    return (
        <div className="mt-12 me-8 self-end z-10 fixed rounded-md border border-hairline bg-canvas shadow-card flex flex-col w-fit p-3 gap-2">
            <TextInput
                type="text"
                placeholder="Enter Identification"
                value={identification}
                onChange={(event) => setIdentification(event.target.value)}
                inputClassName="w-56"
            />
            <TextInput
                type="text"
                placeholder="Enter Name (optional)"
                value={name}
                onChange={(event) => setName(event.target.value)}
                inputClassName="w-56"
            />
            <TextInput
                type="number"
                placeholder="0"
                value={value < 0 ? 0 : value}
                onChange={(event) => setValue(event.target.value)}
                inputClassName="w-56"
            />
            <Button
                variant="primary"
                size="sm"
                onClick={() => {
                    if (value > 0) {
                        props.send(identification, name, value);
                    }
                }}
            >
                Send
            </Button>
        </div>
    );
};

export default SubmissionMenu;
